var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.OH=require("moment");module.exports=$CLJS.OH;